<template>
  <donut-page-sections-two-column title="Reactions">
    <template #left-side>
      <div class="t dark-gray">
        Allow {{ config.points_name_plural }} to be rewarded when someone uses this emoji as a reaction when someone&#32;
        is tagged in a message.
      </div>
      <points-slack-previews-reaction-shoutout class="m-tx1" />
      <points-slack-previews-reaction-shoutout-received-dm :class="`m-tx1 ${reactionsSelection ? null : 'o-25'}`" />
    </template>
    <template #right-side>
      <div class="f-je">
        <donut-input-toggle
          v-model="reactionsSelection"
          update-action="shoutoutsProgram/updateReactionsEnabled"
          :load-on-toggle="true"
        />
      </div>
    </template>
  </donut-page-sections-two-column>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const config = computed(() => state.pointsConfig.config);
  const reactionsSelection = ref(state.shoutoutsProgram.program.reactions_enabled);
</script>
